import type { MasterSearchGroup } from "api/masterSearch";
import { ENTITY_TYPE_LABELS, ENTITY_TYPE_ORDER } from "./constants";

export const orderVisibleGroups = (groups: MasterSearchGroup[]) =>
  [...groups]
    .filter((group) => Boolean(ENTITY_TYPE_LABELS[group.type]))
    .filter((group) => group.items.length > 0)
    .sort(
      (a, b) =>
        ENTITY_TYPE_ORDER.indexOf(a.type) - ENTITY_TYPE_ORDER.indexOf(b.type)
    );

export const flattenGroupItems = (groups: MasterSearchGroup[]) =>
  orderVisibleGroups(groups).flatMap((group) => group.items);

const isSameDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const formatSentAt = (iso: string, now = new Date()): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  if (isSameDay(date, now))
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (isSameDay(date, yesterday)) return "Yesterday";

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    ...(date.getFullYear() === now.getFullYear() ? {} : { year: "numeric" })
  });
};

export const formatConversationTotal = (total: number, capped: boolean) =>
  capped ? `${total}+` : String(total);
